import {
    GETPARENTROLELIST_SUCCESS,
    GETPARENTROLELIST_FAILED,
    RESET_GETPARENTROLELIST,
    LOADING_GETPARENTROLELIST,
    NETWORK_ERROR_GETPARENTROLELIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetParentRoleList = () => {
    return { type: RESET_GETPARENTROLELIST };
};

const getParentRoleList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETPARENTROLELIST });
    await adminServices
        .post("getParentRoleList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getParentRoleListsuccess(res.data));
                    break;
                default:
                    dispatch(getParentRoleListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETPARENTROLELIST, payload: err });
        });
};
function getParentRoleListsuccess(data) {
    return {
        type: GETPARENTROLELIST_SUCCESS,
        payload: data,
    };
}
function getParentRoleListFailed(data) {
    return {
        type: GETPARENTROLELIST_FAILED,
        payload: data,
    };
}

export { resetGetParentRoleList, getParentRoleList };
